export default {
    visitorSettings: 'Visitor Settings',
    envoyConfiguration: 'Envoy Configuration',
    selectSite: 'Select Site',
    selectAccessGroups: 'Select Access Groups',
    saveSettings: 'Save Settings',
};
